module.exports = __webpack_public_path__ + "static/media/icon_filter.e7604e7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_filter.svg
// module id = 1709
// module chunks = 0